import { render, staticRenderFns } from "./TalentMatrixSetting.vue?vue&type=template&id=716e3d4f&scoped=true"
import script from "./TalentMatrixSetting.vue?vue&type=script&lang=js"
export * from "./TalentMatrixSetting.vue?vue&type=script&lang=js"
import style0 from "./TalentMatrixSetting.vue?vue&type=style&index=0&id=716e3d4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716e3d4f",
  null
  
)

export default component.exports